module.exports = __webpack_public_path__ + "static/media/chinese_05.64831999.jpg";